import { useParams } from 'react-router-dom';

export default function SamplePage() {
    const { id } = useParams();

    return <div>SamplePage - {id}</div>;
}
